import styled from "styled-components";

export const Wrapper = styled.div`
display: flex;
justify-content: flex-start;
width: 100%;
align-items: baseline;
flex-direction: column;

`
export const TopPart=styled.div`
    padding-left: 10rem;
    width: 100%;
`
export const Title = styled.span`
color: var(--Dark-Blue-100, #002E5C);
font-family: var(--CommunicationTitleFont-family);
font-size: 20px;
font-style: normal;
font-weight: bolder;
line-height: 32px;
`
export const ToWrapper = styled.div`
    border-bottom: 1px solid rgba(0, 46, 92, 0.1);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    width: 90%;
    padding-top: 20px;
    .emails__wrapper {
      flex: 1;
      min-width: 0;
    }
`
export const ContentMessage = styled.div`
display: flex;
justify-content: space-between;
align-items: flex-start;
width: 100%;

`
export const IphoneMessege = styled.div`
  background:url(${(props) => props.image});
  width: 501px;
  height: 448px;
  background-size: cover;
  position: relative;
  span{
    position: absolute;
    top: 34%;
    left: 38%;
    font-weight: bold;
      }
`
export const Messege = styled.textarea`
position: absolute;
font-family: var(--CommunicationMessegeFont-family);

    top: 50%;
    left: 26%;
    width: 57%;
    border: 1px solid #2555EF;
    border-radius: 10px;
    height: 205px;
    padding: 12px 20px;
    background-color: #2555EF;
    resize: none;
    color:#fff;
    ::placeholder {
        color:#fff;
}
`
export const PushPreview = styled.div`
  position: absolute;
  top: 30%;
  left: 23.1%;
  width: 64%;
  padding: 0 0 28px;
  background: linear-gradient(to bottom, #dce4ee 0%, #dce4ee calc(100% - 28px), transparent 100%);
  border-radius: 14px 14px 14px 14px;
  .notification {
    display: flex;
    flex-direction: column;
    padding: 10px;
    background: #fff;
    border-radius: 14px 14px 14px 14px;
  }
  .notification-header {
    display: flex;
    gap: 8px;
  }
  .app-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #2555ef;
    color: white;
    display: grid;
    place-items: center;
    font-weight: 600;
    flex: 0 0 32px;
    font-size: 14px;
  }
  .notification-content { width: 100%; min-width: 0; }
`
export const PushTitle = styled.input`
  width: 100%;
  border: 2px solid transparent;
  border-bottom-color: white;
  border-radius: 6px;
  color: #002e5c;
  font-weight: 600;
  padding: 5px 7px;
  outline: none;
  &[data-active="true"] {
    border-color: #2555ef;
    background: rgba(37, 85, 239, 0.08);
  }
`
export const PushBody = styled.textarea`
  width: 100%;
  min-height: 64px;
  margin-top: 8px;
  box-sizing: border-box;
  border: 2px solid transparent;
  border-radius: 8px;
  padding: 7px;
  color: #4d5565;
  resize: none;
  outline: none;
  &[data-active="true"] {
    border-color: #2555ef;
    background: rgba(37, 85, 239, 0.08);
  }
`
export const CharacterCount = styled.div`
  color: #8b95a5;
  font-size: 11px;
  text-align: right;
`
export const DynamicTextSection = styled.div`
  margin-top: 0;
`
export const PushLinkFields = styled.div`
  margin-bottom: 4px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 92%;
  max-width: 460px;
  box-sizing: border-box;
`
export const PushLinkSectionTitle = styled.div`
  color: #002e5c;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 2px;
  width: 92%;
  max-width: 460px;
  box-sizing: border-box;
`
export const PushLinkLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #4d5565;
  font-size: 13px;
  font-weight: 600;
`
export const PushLinkInput = styled.input`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #e1e1e7;
  border-radius: 8px;
  padding: 10px 12px;
  color: #002e5c;
  font-family: var(--CommunicationPushLinkInputFont-family);
  font-size: 14px;
  outline: none;
  background: #fff;
  &:focus {
    border-color: #2555ef;
  }
`
export const FieldSelector = styled.fieldset`
  border: 0;
  display: flex;
  gap: 18px;
  margin: 8px 0 10px;
  padding: 0;
  legend { margin-right: 2px; }
  label {
    min-width: 72px;
    padding: 5px 14px;
    border: 1px solid #e1e1e7;
    border-radius: 32px;
    background: #fff;
    color: #4d5565;
    cursor: pointer;
    text-align: center;
  }
  label[data-active="true"] {
    border-color: #2555ef;
    background: #2555ef;
    color: #fff;
  }
  input {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
`
export const TagsWrapper = styled.div`
  width: 45%;
  min-width: 0;
  height: 448px;
  max-height: 448px;
  display: flex;
  flex-direction: column;
`
export const TagsScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 24px 8px 8px 0;
`
export const Tags = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    grid-gap: 8px;
    gap: 8px;
    max-width: 520px;
    font-family: var(--CommunicationTagsFont-family) !important;
    font-weight: 400 !important;
    margin-top: 8px;

  `
export const Tag = styled.button`
border: 0;
border-radius: 20px;
background: rgba(48, 90, 230, 0.20);
display: flex;
padding: 0px 11px;
justify-content: center;
align-items: center;
gap: 8px;
color: #2555EF;
font-size: 14px;
font-weight: 400;
line-height: normal;
text-transform: capitalize;
font-family: var(--CommunicationTagFont-family);

`
export const Buttons =styled.div`
width: 97%;
min-height: 72px;
box-sizing: border-box;
display: flex;
justify-content: space-between;
align-items: center;
flex-shrink: 0;
color: var(--blue, #2555EF);
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 32px;
padding: 12px 0 0;
background: #fff;
`
export const SaveAsDraft =styled.button`
display: flex;
height: 44px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 5px;
flex-shrink: 0;
white-space: nowrap;
background:${(props)=>props.textAreaContent === "" ? "#F0F0F3":"rgba(37, 85, 239, 0.08)"} ;
color:${(props)=>props.textAreaContent === "" ? "#B5B5C3":"var(--Blues-Blue-Main, #2555EF)"}  ;

`
export const Previous = styled.button`
display: flex;
height: 44px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 8px;
border-radius: 5px;
background: rgba(37, 85, 239, 0.08);
margin-right: 30px;
width: 100px;
`
export const Send =styled.button`
display: flex;
width: 147px;
height: 44px;
padding: 8px 20px;
justify-content: center;
align-items: center;
gap: 8px;
flex-shrink: 0;
border-radius: 5px;
background:${(props)=>props.textAreaContent === "" ? "#B5B5C3":"var(--Blues-Blue-Main, #2555EF)"} ;
color:#fff ;
margin-left: 30px;
`
